import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { CreateParticipationSchema, InviteParticipantSchema } from '@app/models/users';
import Api from '@app/services/api';

const coalitionQueryKey = ['coalition'];

export const useCoalitionQuery = () =>
  useQuery({
    queryKey: coalitionQueryKey,
    queryFn: () => Api.users.getCoalition(),
  });

const useCoalitionMutation = <TVariables,>(mutationFn: (variables: TVariables) => Promise<unknown>) => {
  const client = useQueryClient();
  return useMutation({
    mutationFn,
    onSettled: () => client.invalidateQueries(coalitionQueryKey),
  });
};

export const useAddParticipantMutation = () =>
  useCoalitionMutation((data: CreateParticipationSchema) => Api.users.postCoalitionParticipant(data));

export const useInviteParticipantMutation = () =>
  useCoalitionMutation((vars: { uid: string; data: InviteParticipantSchema }) =>
    Api.users.inviteCoalitionParticipant(vars.uid, vars.data)
  );

export const useRevokeInvitationMutation = () =>
  useCoalitionMutation((uid: string) => Api.users.revokeCoalitionInvitation(uid));

export const useDeactivateParticipationMutation = () =>
  useCoalitionMutation((uid: string) => Api.users.deactivateCoalitionParticipation(uid));

export const useReactivateParticipationMutation = () =>
  useCoalitionMutation((uid: string) => Api.users.reactivateCoalitionParticipation(uid));

export const useCustomersQuery = () =>
  useQuery({
    queryKey: ['coalitionCustomers'],
    queryFn: () => Api.users.getCoalitionCustomers(),
  });
